/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Launch_TitleInputs */

const en_directory_footer_launch_title = /** @type {(inputs: Directory_Footer_Launch_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch`)
};

const zh_directory_footer_launch_title = /** @type {(inputs: Directory_Footer_Launch_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布`)
};

/**
* | output |
* | --- |
* | "Launch" |
*
* @param {Directory_Footer_Launch_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_launch_title = /** @type {((inputs?: Directory_Footer_Launch_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Launch_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_launch_title(inputs)
	return zh_directory_footer_launch_title(inputs)
});
export { directory_footer_launch_title as "directory.footer.launch_title" }